import { HttpClient } from '@adapters/HttpClient';

export interface ImpersonateResponse {
    message: string;
    token: string;
    redirect_url: string;
    impersonation_log_id?: number;
}

export class ImpersonateApiAdapter {
    constructor(private httpClient: HttpClient) { }

    // 🎯 Iniciar impersonación
    async startImpersonation(userId: number): Promise<ImpersonateResponse> {
        const response = await this.httpClient.post<ImpersonateResponse>(
            `/users/${userId}/impersonate`,
            {}
        );
        return response;
    }

    // 🎯 Detener impersonación
    async stopImpersonation(impersonationLogId: number): Promise<ImpersonateResponse> {
        const response = await this.httpClient.post<ImpersonateResponse>(
            '/users/impersonate/stop',
            { impersonation_log_id: impersonationLogId }
        );
        return response;
    }
}

